import { getMethod } from "../../api-service/api-service";
import { setAmritVarsha, setSelectedAmritVarsha } from "./amritVarshaSlice";

export const fetchAmritVarshaAction = (params) => async (dispatch) => {
    try {
        const queryString = params ?
            Object.keys(params)
                .filter(key => params[key]) // Remove empty values
                .map(key => `${key}=${encodeURIComponent(params[key])}`)
                .join('&')
            : '';

        const url = `/amrit-varsha${queryString ? `?${queryString}` : ''}`;
        const response = await getMethod(url);
        if (response.success === true) {
            dispatch(setAmritVarsha(response?.amritVarsha));
        };
        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error };
    }
};

export const fetchAmritVarshaDetailsAction = (id) => async (dispatch) => {
    try {
        const response = await getMethod(`/amrit-varsha/${id}`);
        if (response.success === true) {
            dispatch(setSelectedAmritVarsha(response?.amritVarsha));
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error };
    }
}